/* Local dependencies */
import { Service, ServiceStatus, ServiceTypename } from '../utils/types';

export enum ListServicesActionTypes {
  LIST_SERVICES_REQUEST = 'LIST_SERVICES_REQUEST',
  LIST_SERVICES_SUCCESS = 'LIST_SERVICES_SUCCESS',
  LIST_SERVICES_ERROR = 'LIST_SERVICES_ERROR',
  RESET_SELECTED_SERVICE = 'RESET_SELECTED_SERVICE',
  SELECT_SERVICE = 'SELECT_SERVICE',
  REMOVE_SELECTED_SERVICE = 'REMOVE_SELECTED_SERVICE',
  SORT_SERVICES_BY = 'SORT_SERVICES_BY',
  RESET_SERVICES_STATE = 'RESET_SERVICES_STATE',
  PRESS_SERVICE = 'PRESS_SERVICE',
  RESET_PRESS_SERVICE = 'RESET_PRESS_SERVICE',
  GET_LOCALE = 'GET_LOCALE',
  DELETE_SERVICE_POPUP = 'DELETE_SERVICE_POPUP',
}

export interface ListServices {
  type: ListServicesActionTypes.LIST_SERVICES_REQUEST;
  currentPage?: number;
  filter?: ListServicesFilter;
  searchString?: string;
  size?: number;
}

export interface ListServicesSuccess {
  type: ListServicesActionTypes.LIST_SERVICES_SUCCESS;
  services: Service[];
  total: number;
}

export interface ListServicesError {
  type: ListServicesActionTypes.LIST_SERVICES_ERROR;
  error: Error;
}

export interface ListServicesFilter {
  statuses?: [ServiceStatus];
  typename?: [ServiceTypename];
  tags?: string[];
}

export const DEFAULT_SERVICE_FILTER: ListServicesFilter = {};

export interface ListServicesSort {
  type: ListServicesActionTypes.SORT_SERVICES_BY;
  field: string;
}

export interface SelectService {
  type: ListServicesActionTypes.SELECT_SERVICE;
  service: Service;
}

export interface RemoveSelectedService {
  type: ListServicesActionTypes.REMOVE_SELECTED_SERVICE;
  field: any;
}

export interface ResetSelectedService {
  type: ListServicesActionTypes.RESET_SELECTED_SERVICE;
}

export interface ResetServicesState {
  type: ListServicesActionTypes.RESET_SERVICES_STATE;
}

export interface PressService {
  type: ListServicesActionTypes.PRESS_SERVICE;
  service: Service;
}

export interface ResetPressService {
  type: ListServicesActionTypes.RESET_PRESS_SERVICE;
}

export interface GetLocale {
  type: ListServicesActionTypes.GET_LOCALE;
  locale: string;
}

enum Locale {
  EN = 'EN',
  KY = 'KY',
  RU = 'RU',
  TR = 'TR',
}

export interface ListServicesFilterInput {
  statuses: ServiceStatus[];
  typename: ServiceTypename[];
  tags: string[];
}

export interface ListServicesInput {
  filter: ListServicesFilterInput;
  from: number;
  query: String;
  size: number;
  locale: Locale;
}

export type ListServicesAction =
  | GetLocale
  | ListServices
  | ListServicesError
  | ListServicesSuccess
  | PressService
  | ResetPressService
  | ResetSelectedService
  | ResetServicesState
  | SelectService
  | RemoveSelectedService;
